<template>
  <div class="bg-f5f5f5 p-lr-188">
    <div class="footer flex">
      <div class="flex-2">
        <div class="p-l-10">
          <img class="w-128 h-40" @click="goIndex" :src="logo" />
        </div>
        <!-- <div class="p-t-50">
          <img class="w-250 h-160" src="@/assets/home/Snipaste.png" />
        </div> -->
      </div>
      <div class="flex-b flex-8">
        <div>
          <div class="c-fff font-26 p-b-45 font-b">
            {{$t('index.gs')}}
          </div>
          <ul>
            <!-- <li><a @click="path666('/settingAbout')">{{$t('footer.dd')[0].dd[0].title}}</a></li>
            <li><a @click="link">{{$t('footer.dd')[2].dt}}</a></li>
            <li><a @click="path666('/settingHelp')">{{$t('footer.dd')[0].dd[1].title}}</a></li> -->
            <li><a @click="path666('/settingAboutList')">{{$t('footer.dd')[0].dt}}</a></li>
            <li><a @click="path666('/settingJianjie')">{{$t('footer.dd')[0].dd[0].title}}</a></li>
            <!-- <li><a @click="link">{{$t('footer.dd')[2].dt}}</a></li> -->
            <li><a @click="path666('/settingHelp')">{{$t('footer.dd')[0].dd[1].title}}</a></li>
            <li><a>{{$t('langNew.lxyxzc')}}</a></li>
            <li><a>service@fiprobit.com</a></li>
          </ul>
        </div>
        <div>
          <div class="c-fff font-26 p-b-45 font-b">
            {{$t('footer.terms')}}
          </div>
          <ul>
            <li><a @click="path(3,'')">{{$t('footer.dd')[1].dd[0].title}}</a></li>
            <li><a @click="path(5,'')">{{$t('footer.dd')[1].dd[1].title}}</a></li>
            <!-- <li>法律声明</li>
            <li>风险告知</li> -->
          </ul>
        </div>
        <div>
          <div class="c-fff font-26 p-b-45 font-b">
            {{$t('footer.serve')}}
          </div>
          <ul>
            <li><a @click="pathMoney('/recharge', value[key])">{{$t("asset.recharge_btn")[2]}}</a></li>
            <li><a @click="pathMoney('/money', value[key])">{{$t('asset.money_btn')}}</a></li>
            <!-- <li><a @click="jump('/subscription')">{{$t('xbsg.title')}}</a></li> -->
            <!-- <li><a @click="jump('/profit_index')">{{$t('bzhl.title')}}</a></li> -->
            <li><a @click="jump('/currency')">{{$t('wydb.db')}}</a></li>
          </ul>
        </div>
        <div>
          <div class="c-fff font-26 p-b-45 font-b">
            {{$t('footer.product')}}
          </div>
          <ul>
            <!-- <li><a @click="jump('/preciousMetal')">{{$t('langNew.yxhy')}}</a></li> -->
            <li><a @click="jump('/deal_jg?group=1')">{{$t('langNew.qqhy')}}</a></li>
            <!-- <li><a @click="jump('/deal_jg')">{{$t('currency.bb')}}</a></li> -->
          </ul>
        </div>
      </div>
    </div>
    <div class="flex-content font-14 c-929292 p-tb-40">{{ p }}</div>
  </div>
</template>

<script>
import icon1 from "@/assets/index-footer-icon1.png";
import icon2 from "@/assets/index-footer-icon2.png";
import icon3 from "@/assets/index-footer-icon3.png";
import icon4 from "@/assets/index-footer-icon4.png";
import icon5 from "@/assets/index-footer-icon5.png";
import icon6 from "@/assets/index-footer-icon6.png";
import icon7 from "@/assets/index-footer-icon7.png";
import icon8 from "@/assets/index-footer-icon8.png";
import homelogo from "@/assets/home/logo2.png";
import { mapGetters } from "vuex";
import { getLogo,getParam } from "@/api/index";
import { getAsset2 } from '@/api/asset'

export default {
  data() {
    return {
      icon: [[icon1, icon2, icon3, icon4], [icon5, icon6, icon7, icon8]],
      p: this.$t("footer.p"),
      dl: this.$t("footer.dd"),
      flogo: '',
      online_service: '',
      logo:homelogo,
      moneyUnit: 'USDT',
      key: 'bb',
      value:{},
      id: 1,
    };
  },
  computed: {
    ...mapGetters(["token"])
  },
  created(){
    this.online_service = localStorage.getItem('online_service');
    sessionStorage.getItem('web_logo')
    if(this.token){
      this.getAsset();
    }
    // this.logo = sessionStorage.getItem('web_logo') || homelogo
  },
  mounted() {
    // getLogo({key:'web_footer_logo'}).then(res => {
    //   sessionStorage.setItem('web_footer_logo', res)
    //   this.flogo = res
    // });
    getParam().then(res => {
      for(var i=0;i< res.length; i++){
        if(res[i].key == 'android_link'){
          this.android_link = res[i].value.replace(/(^\s*)|(\s*$)/g, "");
        }else if(res[i].key == 'ios_link'){
          this.ios_link = res[i].value.replace(/(^\s*)|(\s*$)/g, "");
        }else if(res[i].key == 'tf_link'){
          this.tf_link = res[i].value.replace(/(^\s*)|(\s*$)/g, "");
        }else if(res[i].key == 'online_service'){
          localStorage.setItem('online_service',res[i].value.replace(/(^\s*)|(\s*$)/g, ""))
        }else if(res[i].key == 'online_service2'){
          localStorage.setItem('online_service2',res[i].value.replace(/(^\s*)|(\s*$)/g, ""))
        }else if(res[i].key == 'ios_link_2'){
          this.ios_link_2 = res[i].value.replace(/(^\s*)|(\s*$)/g, "");
        }else if(res[i].key == 'ios_current_link'){
          this.ios_current_link = res[i].value.replace(/(^\s*)|(\s*$)/g, "");
        }
      }
    });
  },
  methods: {
    getAsset(){
      getAsset2({ id: this.id }).then(res => {
        // if(this.check){
        //   this.list = res.list.filter((item) =>{
        //     return item.positions > 0;
        //   })
        // }else{
        //   this.list = res.list
        // }
        // this.totalMoney = res.totalMoney.toFixed(4);
        this.value.bb = res.list.find(o=>o.currency=='USDT')
        this.value.bb.type=1
        this.value.bb.unit = this.moneyUnit
        this.value.bb.money = res.totalMoney
      })
    },
    pathMoney(p, o) {
      if(!o){
        this.$router.push('/login');
        return
      };
      this.$store.dispatch('updateData', o)
      localStorage.setItem('jyxt_asset_table_path', JSON.stringify(o));
      this.$router.push({ path: p })
    },
    goIndex(){
      this.$router.push('/index');
    },
    path666(url) {
      this.$router.push(url);
    },
    path(id,type) {
      if(type == 'help'){
        this.$router.push({
          path: "/help",
          query: { id,type }
        });
      }else if(id == 1){
        this.$router.push({
          path: "/about",
          query: { id,type }
        });
      }else if(id == 3){
        this.$router.push("/agrt");
      }else{
        this.$router.push("/text");
      }
    },
    jump(url){
      this.$router.push(url);
    },
    link(){
      if(!this.online_service) return;
      window.open(this.online_service);
    }
  }
};
</script>

<style scoped lang="scss">
  .footer{
    padding: .84rem 0 .2rem;
  }
  .footer ul li {
    font-size: .22rem;
    color: #000;
    padding: 15px 0;
  }
  .footer ul li a{
    font-size: .22rem;
  }

// .footer{ width:100%; background-color:#040f1f; margin-top:70px;}
// .footer .foot{ width:1200px; margin:auto; padding:50px 0;}
// .footer .foot .f01{ width:23%; float:left;}
// .footer .foot .f01 img{ display:block; margin-top:40px;}
// .footer .foot .f02{ width:35%; float:left; display:block;}
// .footer .foot .f02 dt{ display:block; font-size:20px; line-height:30px; text-transform:uppercase; color:#000000;}
// .footer .foot .f02 dt b{ display:block; width:30px; height:2px; background-color:#00d5fd; overflow:hidden; margin:10px 0;}
// .footer .foot .f02 dd{ display:block; overflow:hidden;}
// .footer .foot .f02 dd a{ display:block; width:45%; float:left; font-size:16px; line-height:26px; color:#000000;}
// .footer .foot .f02 dd a:hover{ color:#00d5fd;}
// .footer .foot .f03{ width:20%; float:right; display:block;}
// .footer .foot .f03 dt{ display:block; font-size:20px; line-height:30px; text-transform:uppercase; color:#000000;}
// .footer .foot .f03 dt b{ display:block; width:30px; height:2px; background-color:#00d5fd; overflow:hidden; margin:10px 0;}
// .footer .foot .f03 dd{ display:block; overflow:hidden;}
// .footer .foot .f03 dd a{ display:block; width:100%; float:left; font-size:16px; line-height:26px; color:#000000;}
// .footer .foot .f03 dd a:hover{ color:#00d5fd;}
// .footer .bq{ text-align:center; width:100%; background-color:#010711; padding:15px 0; font-size:14px; line-height:24px; color:#99b3da;}
</style>



// WEBPACK FOOTER //
// src/components/AoFooter.vue